import axiosInstance from "../helpers/axiosInstance"

export const fetchWorkOrders = async (params) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/work-orders`, { params })
    return res.data
}
export const createWorkOrder = async (params) => {
    const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/work-orders`, params)
    return res.data
}